<template>
    <div class="faq-page">
      <div class="header">
        <div class="d-flex align-items-center justify-content-center w-100 flex-column">
          <div class="faq">How may we help you?</div>
          <div class="search-bar">
                <b-form @submit.prevent="">
                <b-input-group class="border-inp border-dark rounded">
                    <b-form-input class="py-4 border-0 no-outline" placeholder="Search..." @keyup.enter="loadSupCon" v-model="searchQuery"></b-form-input>
                    <b-input-group-append>
                        <b-button class="bg-white btn border-0 no-outline text-gray px-4 btn-hover">
                            <b-icon-search @click="loadSupCon"></b-icon-search>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form>
            </div>
        </div>
      </div>
      <div class="support-section">
        <!-- <div class="mb-4" v-for="item in SupCon" :key="item.Q">
          <div class="faq-q">{{ item.question }}</div>
          <div class="faq-a">
            <div v-html="item.description"></div>
            
          </div>
        </div> -->
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1" v-for="(item, index) in SupCon" :key="item.question">
            <b-card-header header-tag="header" class="p-1" role="tab" @click="displayShort(index)">
              <b-button block v-b-toggle="'accordion-'+index">
                <div class="d-flex justify-content-between">
                  <div v-if="item.disp">
                    <div><b v-html="item.question"></b></div>
                    <div v-html="item.description.substring(0, 50)+'...'"></div>
                  </div>
                  <div v-else><b v-html="item.question"></b></div>
                  <div class="arrow"><b-icon-chevron-down /></div>
                </div>
              </b-button>
            </b-card-header>
            <b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text v-html="item.description"></b-card-text>
                <b-card-text v-if="item.videoUrl">
                  <div class="faq-vid">
                    <iframe :src="`https://www.youtube.com/embed/${item.videoUrl}?autoplay=0&mute=0`">
                    </iframe>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import api from '../../module_dashboard/api.js';
  export default {
    data: function () {
      return {
        SupCon: [],
        searchQuery: '',
        currentVid: 0
      };
    },
    async created() {
      this.loadSupCon();
    },
    methods: {
      async loadSupCon(){
        const params = {search: this.searchQuery}
        const response = await api.SupportContent(params);
        this.SupCon = [];
        if(response){
          response.data.data.map(ele => {
            this.SupCon.push({...ele, disp: true, videoUrl: ele?.videoUrl?.split('/')[3]})
          });
        }
      },

      displayShort(ind){
        if(this.SupCon[ind].disp === false){
          this.SupCon[ind].disp = true;
          return;
        }
        this.SupCon.forEach(ele => {
          ele.disp = true;
        })
        this.SupCon[ind].disp = false;
        this.currentVid = ind
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .faq-page {
    font-family: Kanit-Regular;
  }
  iframe{
    width: 75%;
    height: 400px;
    border: none;
  }
  .header {
    padding: 5% 5% 1% 5%;
    background-image: url("../assets/images/faq-banner.jpg");
    background-size: cover;
  }
  .support-section {
    padding: 2% 10%;
  }
  .faq {
    color: #fff;
    font-size: 34px;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .arrow{
    transform: rotateX(0deg);
    transition: 1s ease;
  }
  .not-collapsed .arrow{
    transform: rotateX(180deg);
  }
  .card{
    border: none;
  }
  .card-header{
    border: none;
    box-shadow: none !important;
  }
  .btn-secondary{
    color: #000 !important;
    background-color: white;
    border: none;
    text-decoration: none !important;
    box-shadow: none !important;
    text-align: left;
  }
  .faq-vid{
    display: flex;
    align-items: start;
    justify-content: start;
  }
  .search-bar{
    width: 70%;
    height: 40px;
    position: relative;
    margin-bottom: 50px;
    border-radius: 20px;

    .border-inp{
        border: 3px solid;
    }
    .no-outline:focus{
        box-shadow: none !important;
    }
    .btn-hover:hover{
        background-color: #d8f1b6;
        color: black;
    }
}
.pagination-action {
    margin: 16px auto;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep pagination {
      display: flex;
    }

    ::v-deep li {
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      margin-right: 16px;
      border: 1px solid black;
      border-radius: 5px;
      background-color: #ffffff;
      flex-grow: 0 !important;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background-color: #73bd45;

        .page-link {
          color: #ffffff;
        }
      }
    }

    ::v-deep .page-link {
      border: none;
      box-shadow: none;
      background: transparent;
      color: black;
      margin: 0;
      padding: 0.25rem 0.8rem;
    }
  }
  ::v-deep ul{
    margin-left: 1.5em !important;
  }
  ::v-deep ol{
    margin-left: 1.5em !important;
  }
@media screen and (max-width: 568px) {
  .search-bar{
    width: 90%;
  }

  .faq{
    font-size: 25px;
    margin-bottom: 1rem;
  }
  
  iframe{
    width: 100%;
    height: 300px;
  }

  .support-section {
    padding: 2% 2%;
  }

  .card-body{
    padding: .5rem;
  }
}
  </style>
  